export default "__VITE_ASSET__B_saOB0K__"